import React, { createContext, useContext, useEffect, useMemo } from "react";
import { resolveColors } from "../../lib/colorUtils";

export const ThemeContext = createContext();

const DEFAULT_PRIMARY = "rgb(105, 105, 105)";

export const ThemeProvider = ({ children, primary, secondary, tertiary }) => {
  const resolvedColors = useMemo(
    () => resolveColors(primary || DEFAULT_PRIMARY),
    [primary],
  );

  const theme = useMemo(
    () => ({
      mainColor: primary || DEFAULT_PRIMARY, // backward compat for existing consumers
      primaryColor: primary || DEFAULT_PRIMARY,
      secondaryColor: secondary || resolvedColors.bg,
      tertiaryColor: tertiary || null,
      resolvedColors,
    }),
    [primary, secondary, tertiary, resolvedColors],
  );

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--primary-color", theme.primaryColor);
    root.style.setProperty("--secondary-color", theme.secondaryColor);
    root.style.setProperty(
      "--lighter-primary-color",
      resolvedColors.lightVariant,
    ); // backward compat
    if (theme.tertiaryColor) {
      root.style.setProperty("--tertiary-color", theme.tertiaryColor);
    }
  }, [theme, resolvedColors]);

  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
